import { FC } from 'react'

import { B2CTypeTable } from '@/types.ts'
import { PersonCustomizationDialog } from '@/components/person-customization-dialog.tsx'
import { useMutatePersonalSettings } from '@/services'
import { RowProps } from '@/components/dnd-area/draggable-row.tsx'
import { useB2CState } from '@/stores/slices/b2c-slice'
import { useAppSelector } from '@/stores/hooks.ts'
import { userSelectors } from '@/stores/slices/user-slice.ts'

import {
  KEY_PAGE as KEY_PAGE_B2C_REGISTRIES,
  PartialRegistriesRequest,
  defaultSettings as DEFAULT_SETTINGS_REGISTRIES,
} from '../default-settings-registries.tsx'
import {
  KEY_PAGE as KEY_PAGE_B2C_PAYMENTS,
  PartialPaymentsRequest,
  defaultSettings as DEFAULT_SETTINGS_PAYMENTS,
} from '../default-settings-payments.tsx'

export const B2CPersonalSettings: FC = () => {
  const { b2cType } = useB2CState()
  const settingsForPayments = useAppSelector((state) => userSelectors.personalSettings(state, KEY_PAGE_B2C_PAYMENTS))
  const settingsForRegistries = useAppSelector((state) =>
    userSelectors.personalSettings(state, KEY_PAGE_B2C_REGISTRIES)
  )

  const getSettingsPayments = (format: string, personalSettings?: Record<string, string[]>) => {
    const settingsByRequest = personalSettings?.[format] ?? Object.keys(DEFAULT_SETTINGS_PAYMENTS)
    const settings: RowProps[] = settingsByRequest.map((e) => ({
      id: e,
      label: DEFAULT_SETTINGS_PAYMENTS[e as keyof PartialPaymentsRequest],
      isChecked: true,
    }))
    Object.keys(DEFAULT_SETTINGS_PAYMENTS).forEach((key) => {
      if (!settingsByRequest.includes(key)) {
        settings.push({
          id: key,
          label: DEFAULT_SETTINGS_PAYMENTS[key as keyof PartialPaymentsRequest],
          isChecked: false,
        })
      }
    })

    return settings
  }

  const getSettingsRegistries = (format: string, personalSettings?: Record<string, string[]>) => {
    const settingsByRequest = personalSettings?.[format] ?? Object.keys(DEFAULT_SETTINGS_REGISTRIES)
    const settings: RowProps[] = settingsByRequest.map((e) => ({
      id: e,
      label: DEFAULT_SETTINGS_REGISTRIES[e as keyof PartialRegistriesRequest],
      isChecked: true,
    }))
    Object.keys(DEFAULT_SETTINGS_REGISTRIES).forEach((key) => {
      if (!settingsByRequest.includes(key)) {
        settings.push({
          id: key,
          label: DEFAULT_SETTINGS_REGISTRIES[key as keyof PartialRegistriesRequest],
          isChecked: false,
        })
      }
    })

    return settings
  }

  const mutation = useMutatePersonalSettings()

  return b2cType === B2CTypeTable.REGISTRIES ? (
    <PersonCustomizationDialog
      personalSettingsKey={KEY_PAGE_B2C_REGISTRIES}
      mutation={mutation}
      itemsDesktop={getSettingsRegistries('desktop', settingsForRegistries)}
      itemsMobile={getSettingsRegistries('mobile', settingsForRegistries)}
    />
  ) : (
    <PersonCustomizationDialog
      personalSettingsKey={KEY_PAGE_B2C_PAYMENTS}
      mutation={mutation}
      itemsDesktop={getSettingsPayments('desktop', settingsForPayments)}
      itemsMobile={getSettingsPayments('mobile', settingsForPayments)}
    />
  )
}
